import React from 'react';
import FlagPopUp from '../../FlagPopUp/FlagPopUp';
import { buttonClass } from '../../components/ui/Button';

function DroneStatus({
    drone,
    flag,
    showPopUp,
    updatedDrone,
    toggleFlagPopup,
    flagDrone,
    oocDrone,
    updateState,
    userid,
    activeRMA,
    onRMAClick
}) {
    // Format RMA status for display
    const getRMAStatusText = () => {
        if (!activeRMA) return null;
        if (activeRMA.item_status === 'pending_review') return 'Pending Review';
        if (activeRMA.item_status === 'rejected') return 'Rejected';
        const repair = activeRMA.repair_status || 'pending';
        return `Repair: ${repair.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}`;
    };

    return (
        <>
            {activeRMA ? (
                /* Active RMA Banner - replaces status panel */
                <div
                    onClick={() => onRMAClick && onRMAClick(activeRMA.rma_number)}
                    className="bg-primary/20 border-2 border-primary rounded mb-3 cursor-pointer
                        hover:bg-primary/30 transition-all duration-200
                        shadow-[0_0_12px_rgba(255,204,51,0.3)] hover:shadow-[0_0_20px_rgba(255,204,51,0.5)]"
                >
                    <div className="px-3 py-2 flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <span className="text-primary-ink text-xs font-bold px-2 py-0.5 bg-primary/30 rounded">RMA</span>
                            <span className="text-white text-sm font-medium">
                                {activeRMA.issue_category
                                    ? activeRMA.issue_category.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
                                    : activeRMA.rma_number}
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-primary text-xs">{getRMAStatusText()}</span>
                            <span className="text-primary">››</span>
                        </div>
                    </div>
                </div>
            ) : drone.condition === 'RTF' ? (
                /* Compact RTF status - just header bar with shine effect */
                <div className={`bg-[#242424] rounded mb-3 border ${getBorderColor(drone.condition)} shine-rtf`}>
                    <div className={`px-3 py-2 ${getHeaderBg(drone.condition)}`}>
                        <div className="text-sm text-white">
                            <span className="text-on-surface-variant">Status:</span> Ready to Fly
                        </div>
                    </div>
                </div>
            ) : (
                /* Prominent Flag/OOC status - header + large text */
                <div className={`relative bg-[#242424] rounded overflow-hidden mb-3 border ${getBorderColor(drone.condition)} ${getGlowAnimation(drone.condition)}`}>
                    <div className={`px-3 py-2 border-b border-black/30 ${getHeaderBg(drone.condition)}`}>
                        <div className="text-xs text-white/80 uppercase tracking-wide font-semibold">
                            Status
                        </div>
                    </div>
                    <div className='text-white text-2xl font-semibold text-center py-6'>
                        {flag}
                    </div>
                </div>
            )}

            {/* Flag Popup - renders outside status box */}
            {showPopUp && (
                <FlagPopUp
                    drone={drone}
                    drone_serial={drone.serialnumber}
                    statusdesc={updatedDrone.condition}
                    userid={userid}
                    updateState={updateState}
                    closePopup={toggleFlagPopup}
                />
            )}
            <div className='flex gap-3 mb-3'>
                {drone.condition !== 'OOC' && (
                    <button
                        className={`${buttonClass('accent', 'lg')} flex-1`}
                        type='button'
                        aria-pressed={drone.condition === 'Flag'}
                        onClick={flagDrone}
                    >
                        <span>{drone.condition === 'Flag' ? 'UNFLAG' : 'FLAG'}</span>
                    </button>
                )}
                {drone.condition !== 'Flag' && (
                    <button
                        className={`${buttonClass(drone.condition === 'OOC' ? 'tonal' : 'danger-quiet', 'lg')} flex-1`}
                        type='button'
                        aria-pressed={drone.condition === 'OOC'}
                        onClick={oocDrone}
                    >
                        <span>{drone.condition === 'OOC' ? 'UNOOC' : 'OOC'}</span>
                    </button>
                )}
            </div>
        </>
    );
}

function getBorderColor(condition) {
    switch(condition) {
        case 'RTF': return 'border-[#22c55e]';
        case 'Flag': return 'border-primary';
        case 'OOC': return 'border-danger';
        default: return 'border-gray-700';
    }
}

function getHeaderBg(condition) {
    switch(condition) {
        case 'RTF': return 'bg-[#22c55e]/20';
        case 'Flag': return 'bg-primary/20';
        case 'OOC': return 'bg-danger/30';
        default: return 'bg-gray-900/40';
    }
}

function getGlowAnimation(condition) {
    const baseAnimation = 'transition-shadow duration-1000';
    switch(condition) {
        case 'RTF':
            return `${baseAnimation} shadow-[0_0_20px_rgba(34,197,94,0.6)] hover:shadow-[0_0_30px_rgba(34,197,94,0.8)] glow-green`;
        case 'Flag':
            return `${baseAnimation} shadow-[0_0_20px_rgba(255,204,51,0.6)] hover:shadow-[0_0_30px_rgba(255,204,51,0.8)] glow-yellow`;
        case 'OOC':
            return `${baseAnimation} shadow-[0_0_20px_rgba(187,51,51,0.7)] hover:shadow-[0_0_30px_rgba(187,51,51,0.9)] glow-red`;
        default:
            return '';
    }
}

export default DroneStatus;
